import {
  PAYZE_PROVIDER_FETCH_SUCCESS,
  DOWNLOAD_PAYZE_PROVIDER_SUCCESS
} from '../constant/actionType';

const initialState = {
  csv: null,
  isLoaded: true,
  payzeProviders: []
};

const payzeProviderReducer = (state = initialState, action) => {
  switch (action.type) {
    case PAYZE_PROVIDER_FETCH_SUCCESS:
      return {
        ...state,
        isLoaded: false,
        payzeProviders: action.data
      };

    case DOWNLOAD_PAYZE_PROVIDER_SUCCESS:
      return {
        ...state,
        csv: action.data
      };

    default:
      return state;
  }
};

export default payzeProviderReducer;
